export default {
  root: {
    padding: "8px 16px 16px 16px",
  },
};
